import { Badge } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

interface CompletionBadgeProps {
  completedFields: number;
  totalFields: number;
}

export const CompletionBadge = ({
  completedFields,
  totalFields,
}: CompletionBadgeProps) => {
  const { t } = useTranslation();

  if (totalFields === 0) return null;

  return completedFields === totalFields ? (
    <Badge appearance="filled" color="success" size="small">
      {t('completed', 'Completed')}
    </Badge>
  ) : (
    <Badge appearance="filled" color="warning" size="small">
      {t('inProgress', 'In progress')}
    </Badge>
  );
};
